module.exports = __webpack_public_path__ + "img/248.4f721ae0.jpg";